export default "__VITE_ASSET__JRJAC9$9__"